import { render, staticRenderFns } from "./LessonView.vue?vue&type=template&id=183c4f2e&"
import script from "./LessonView.vue?vue&type=script&lang=js&"
export * from "./LessonView.vue?vue&type=script&lang=js&"
import style0 from "./LessonView.vue?vue&type=style&index=0&id=183c4f2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports